import Vue from 'vue'
import $ from 'jQuery'
import _ from 'lodash'
import $glDom from '@/services/$glDom'

/*
  how to use:
    v-gl-on-click-away="closePopover"
*/
Vue.directive('gl-on-click-away', {
  // on insert
  inserted (el, binding) {
    // declare namespace
    el.namespace = 'gl-on-click-away--' + _.random(0, 1000000)

    // declare css
    el.css = '#app, .modal-content'

    // bind click event
    $glDom.bindClick({ css: el.css, namespace: el.namespace }, (event) => {
      // if click is outside the inserted element
      if (!$(event.target).parents(el).is(el)) {
        // call callback
        binding.value()
      }
    })
  },

  // on unbind
  unbind (el) {
    // unbind click event
    $glDom.unbindClick({ css: el.css, namespace: el.namespace })
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-on-click-away.js